import React, { Component, useEffect } from 'react';
//import logo from './logo.svg';
import './App.css';
import Header from './Header.js'
import Home from './Home.js'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import Checkout from './Checkout.js'
import Login from './Login.js'
import Payment from './Payment.js'
import Orders from './Orders.js'
import { auth } from './firebase.js'
import { useStateValue } from './StateProvider.js';

import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js';

const promise = loadStripe('pk_test_51HW7b9DERolhF7cUbM4AWScQX6HP1S5rSOM3VNvLjVPWJC1K3KEbqtUyL1Z6aohehyQtP6Nno4aAh9AxXneUcL1M00jj1tgFUm')

function App(){

  const [{}, dispatch] = useStateValue();

    useEffect(() => {
      //will only run once when the app component loads..
      auth.onAuthStateChanged(authUser => {
        console.log('THE USER IS >>>', authUser);
      

      if(authUser){
        //User is logged in:
        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      }else{
        //User is logged out:
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    
    })
   },[])
    

    return (
      <Router>
        <div className="app">
          


          <Switch>

            <Route path="/checkout">
              <Header />
              <Checkout />
            </Route>

            <Route path="/orders">
              <Header />
              <Orders />
            </Route>

            <Route path="/login">
                <Login />
            </Route>

            <Route path="/payment">
                <Header />
                <Elements stripe={promise}>
                  <Payment />
                </Elements>
            </Route>

              <Route path="/">
                <Header />
                <Home />
              </Route>

              
            

          </Switch>
        
        </div>
      </Router>
    );
  
  }



export default App;
